<template>
    <div>
        <template v-for="(item, index) in FormField">
            <el-form-item
                :key="index"
                :label="item.label"
                :label-width="formLabelWidth"
                :prop="item.field"
                v-show="!item.hidden"
                v-if="item.form_type == 'text' || item.form_type == 'textarea' || item.form_type == 'number' || item.form_type == 'floatnumber' || item.form_type == 'mobile' || item.form_type == 'email' || item.form_type == 'password' || item.form_type == 'hidden'"
            >
                <el-input
                    v-model="FormModel[item.field]"
                    :type="item.form_type"
                    :placeholder="item.input_tips"
                    :suffix-icon="item.icon"
                    :disabled="item.disabled"
                    autocomplete="off"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item
                :key="index"
                :label="item.label"
                :label-width="formLabelWidth"
                :prop="item.field"
                v-else-if="item.form_type == 'select'"
            >
                <el-select
                    v-model="FormModel[item.field]"
                    :placeholder="item.input_tips"
                    clearable
                    :filterable="item.filterable"
                    @change="selectChange(item)"
                >
                    <el-option
                        v-for="(opt, idx) in item.setting"
                        :key="idx"
                        :label="opt.label"
                        :value="opt.value"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                :key="index"
                :label="item.label"
                :label-width="formLabelWidth"
                :prop="item.field"
                v-else-if="item.form_type == 'select_course'"
            >
                <el-input
                    v-model="courseLabel"
                    :type="item.form_type"
                    :placeholder="item.input_tips"
                    @focus="openSelectCourse(item)"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item
                :key="index"
                :label="item.label"
                :label-width="formLabelWidth"
                :prop="item.field"
                v-else-if="item.form_type == 'switch'"
            >
                <el-switch
                    v-model="FormModel[item.field]"
                >
                </el-switch>
            </el-form-item>
            <el-form-item
                :key="index"
                :label="item.label"
                :label-width="formLabelWidth"
                :prop="item.field"
                v-else-if="item.form_type == 'radio'"
            >
                <el-radio-group
                    v-model="FormModel[item.field]"
                >
                    <el-radio
                        v-for="(opt, idx) in item.setting"
                        :key="idx"
                        :label="opt.label"
                        :value="opt.value"
                    ></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item
                :key="index"
                :label="item.label"
                :label-width="formLabelWidth"
                :prop="item.field"
                v-else-if="item.form_type == 'daterange'"
            >
                <el-date-picker
                    v-model="FormModel[item.field]"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
        </template>
    </div>
</template>

<script>
import { getSelectData } from "@/utils/form";
import SelectCourse from "@/components/Element/CreateCom/SelectCourse/index";
export default {
    name: "form-com",
    props: {
        FormModel: {
            type: Object
        },
        FormField: {
            type: Array
        },
        formLabelWidth: {
            type: [String, Number],
            default: ""
        },
        FormData: {
            type: Object
        }
    },
    data() {
        return {
            formData: {},
            courseLabel: '',
        };
    },
    methods: {
        selectChange (item) {
            if (item.linkage) {
                this.getLinkageData(item)
            }
        },
        async getLinkageData (item) {
            let linkage = item.linkage
            let params = linkage.params
            params[linkage.linkage_field] = this.FormModel[item.field]
            let result = await linkage.api(params)
            if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                let selectList = getSelectData(
                    result.data,
                    "name",
                    "id"
                );
                for (let i in this.FormField) {
                    if (this.FormField[i].field == linkage.field) {
                        this.FormModel[linkage.field] = ''
                        this.FormField[i].setting = selectList
                    }
                }
            } else {
                this.$message({
                    message: result.msg,
                    type: "warning"
                });
            }
        },
        // 选择课程
        openSelectCourse (item) {
            let data = {
                student_id: this.FormData.student_id
            };
            SelectCourse({
                data,
                success: result => {
                    this.FormModel[item.field] = result.id
                    this.courseLabel = result.name
                    this.$message({
                        message: '操作成功',
                        type: "success"
                    });
                }
            });
        }
    },
    watch: {},
    mounted() {}
};
</script>